import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "tariffOptionElementarAddressDiv",
  class: "o-grid o-grid--align-middle o-grid--no-y-gutter gev19-elementar-addresscheck initiallyHidden"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12" }
const _hoisted_3 = { id: "validierungsFehler" }
const _hoisted_4 = {
  key: 0,
  class: "gevng-form-validation__error-container"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "c-form-control u-text-align-right parsley-success",
  style: {"padding-top":"8px"}
}
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adresse = _resolveComponent("adresse")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_modal = _resolveComponent("modal")!
  const _component_timeout_modal = _resolveComponent("timeout-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      id: "elementarForm",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ermittleZuersUndBerechneNeu && _ctx.ermittleZuersUndBerechneNeu(...args)), ["prevent"])),
      novalidate: ""
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12" }, [
          _createElementVNode("span", { class: "gev19-optional-module-subheading" }, "Versicherungsort")
        ], -1)),
        _createVNode(_component_adresse, {
          fehler: _ctx.fehler,
          placeholder: true,
          "zeige-fehler": false,
          plz: _ctx.piniaStore.state.risikoAnschrift.plz,
          "onUpdate:plz": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.plz) = $event)),
          ort: _ctx.piniaStore.state.risikoAnschrift.ort,
          "onUpdate:ort": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.ort) = $event)),
          strasse: _ctx.piniaStore.state.risikoAnschrift.strasse,
          "onUpdate:strasse": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.strasse) = $event)),
          hausnummer: _ctx.piniaStore.state.risikoAnschrift.hausnummer,
          "onUpdate:hausnummer": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.risikoAnschrift.hausnummer) = $event)),
          feldNamen: {
          plz: 'risikoPlz',
          ort: 'risikoOrt',
          strasse: 'risikoStrasse',
          hausnummer: 'risikoHausnummer',
        },
          "deaktivierte-felder": _ctx.deaktivierteFelder,
          ref: "risikoAdresseRef",
          titel: {
          breite: 3,
          ausrichtungResponsiv: false,
        },
          "ort-format": {
          breite: 6,
        },
          "strasse-format": {
          breite: 7,
        },
          "hausnummer-format": {
          breite: 2,
          style: 'width:100%',
        },
          "zeile-class": "adressZeile"
        }, {
          strasseHausnummerLabel: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Straße und Nr.")
          ])),
          _: 1
        }, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "deaktivierte-felder"]),
        _createVNode(_component_validierungs_fehler, { "fehler-text": _ctx.fehlerMsg }, null, 8, ["fehler-text"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.risikoOrt
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.risikoStrasse
            }, null, 8, ["fehler-text"]),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.risikoHausnummer
            }, null, 8, ["fehler-text"]),
            (_ctx.zeigePruefungNichtErfolgt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.piniaStore.state.isMakler)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[6] || (_cache[6] = [
                        _createElementVNode("p", null, "Online können wir Ihnen kein Vorschlag für den Einschluss der Elementargefahren erstellen.", -1),
                        _createElementVNode("p", null, " Bitte rufen Sie im Maklervertriebscenter unter der Telefonnummer 040 3766 3222 an. Sie erreichen uns von Montag bis Freitag von 8:00 bis 18:00 Uhr. ", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, " Bitte prüfen und berechnen Sie die Naturgewalten, bevor Sie fortfahren oder deaktivieren Sie diese Erweiterung. "))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              disabled: _ctx.erfolgreichGeprueft,
              id: "btnCheckAndCalculateElementar",
              class: "c-button"
            }, _toDisplayString(_ctx.erfolgreichGeprueft ? "Prüfung erfolgreich!" : "Prüfen & Berechnen"), 9, _hoisted_8)
          ])
        ]),
        (_ctx.zeigeModal)
          ? (_openBlock(), _createBlock(_component_modal, {
              key: 0,
              onCloseModal: _ctx.toggleElementCheck,
              hatSchliessenButton: true,
              schliessenButtonText: _ctx.buttonText,
              titel: "Naturgewalten (Elementar)",
              text: _ctx.modalText
            }, null, 8, ["onCloseModal", "schliessenButtonText", "text"]))
          : _createCommentVNode("", true)
      ])
    ], 32),
    (_ctx.istSichtbar('modal-timeout'))
      ? (_openBlock(), _createBlock(_component_timeout_modal, {
          key: 0,
          "erste-seite": _ctx.piniaStore.state.isMakler ? '/makler/vhv' : '/vhv',
          onRetry: _ctx.retry
        }, null, 8, ["erste-seite", "onRetry"]))
      : _createCommentVNode("", true)
  ], 64))
}